/**
 * @fileoverview This file is generated by the Angular 2 template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties}
 */
/* tslint:disable */
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
import * as import0 from '../../../app/nav/nav.component';
import * as import1 from '@angular/core/src/linker/view';
import * as import3 from '@angular/core/src/linker/view_utils';
import * as import4 from '@angular/core/src/metadata/view';
import * as import5 from '@angular/core/src/linker/view_type';
import * as import6 from '@angular/core/src/change_detection/constants';
import * as import7 from '@angular/core/src/linker/component_factory';
import * as import8 from '../../node_modules/@angular/router/src/directives/router_link.ngfactory';
import * as import9 from '@angular/router/src/router';
import * as import10 from '@angular/router/src/router_state';
import * as import11 from '@angular/common/src/location/location_strategy';
import * as import12 from '@angular/router/src/directives/router_link';
export var Wrapper_NavComponent = (function () {
    function Wrapper_NavComponent() {
        this._changed = false;
        this.context = new import0.NavComponent();
    }
    Wrapper_NavComponent.prototype.ngOnDetach = function (view, componentView, el) {
    };
    Wrapper_NavComponent.prototype.ngOnDestroy = function () {
    };
    Wrapper_NavComponent.prototype.ngDoCheck = function (view, el, throwOnChange) {
        var changed = this._changed;
        this._changed = false;
        return changed;
    };
    Wrapper_NavComponent.prototype.checkHost = function (view, componentView, el, throwOnChange) {
    };
    Wrapper_NavComponent.prototype.handleEvent = function (eventName, $event) {
        var result = true;
        return result;
    };
    Wrapper_NavComponent.prototype.subscribe = function (view, _eventHandler) {
        this._eventHandler = _eventHandler;
    };
    return Wrapper_NavComponent;
}());
var renderType_NavComponent_Host = import3.createRenderComponentType('', 0, import4.ViewEncapsulation.None, [], {});
var View_NavComponent_Host0 = (function (_super) {
    __extends(View_NavComponent_Host0, _super);
    function View_NavComponent_Host0(viewUtils, parentView, parentIndex, parentElement) {
        _super.call(this, View_NavComponent_Host0, renderType_NavComponent_Host, import5.ViewType.HOST, viewUtils, parentView, parentIndex, parentElement, import6.ChangeDetectorStatus.CheckAlways);
    }
    View_NavComponent_Host0.prototype.createInternal = function (rootSelector) {
        this._el_0 = import3.selectOrCreateRenderHostElement(this.renderer, 'my-nav', import3.EMPTY_INLINE_ARRAY, rootSelector, null);
        this.compView_0 = new View_NavComponent0(this.viewUtils, this, 0, this._el_0);
        this._NavComponent_0_3 = new Wrapper_NavComponent();
        this.compView_0.create(this._NavComponent_0_3.context);
        this.init(this._el_0, (this.renderer.directRenderer ? null : [this._el_0]), null);
        return new import7.ComponentRef_(0, this, this._el_0, this._NavComponent_0_3.context);
    };
    View_NavComponent_Host0.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import0.NavComponent) && (0 === requestNodeIndex))) {
            return this._NavComponent_0_3.context;
        }
        return notFoundResult;
    };
    View_NavComponent_Host0.prototype.detectChangesInternal = function (throwOnChange) {
        this._NavComponent_0_3.ngDoCheck(this, this._el_0, throwOnChange);
        this.compView_0.detectChanges(throwOnChange);
    };
    View_NavComponent_Host0.prototype.destroyInternal = function () {
        this.compView_0.destroy();
    };
    View_NavComponent_Host0.prototype.visitRootNodesInternal = function (cb, ctx) {
        cb(this._el_0, ctx);
    };
    return View_NavComponent_Host0;
}(import1.AppView));
export var NavComponentNgFactory = new import7.ComponentFactory('my-nav', View_NavComponent_Host0, import0.NavComponent);
var styles_NavComponent = [];
var renderType_NavComponent = import3.createRenderComponentType('', 0, import4.ViewEncapsulation.None, styles_NavComponent, {});
export var View_NavComponent0 = (function (_super) {
    __extends(View_NavComponent0, _super);
    function View_NavComponent0(viewUtils, parentView, parentIndex, parentElement) {
        _super.call(this, View_NavComponent0, renderType_NavComponent, import5.ViewType.COMPONENT, viewUtils, parentView, parentIndex, parentElement, import6.ChangeDetectorStatus.CheckAlways);
        this._arr_70 = import3.pureProxy1(function (p0) {
            return [p0];
        });
        this._arr_71 = import3.pureProxy1(function (p0) {
            return [p0];
        });
        this._arr_72 = import3.pureProxy1(function (p0) {
            return [p0];
        });
        this._arr_73 = import3.pureProxy1(function (p0) {
            return [p0];
        });
        this._arr_74 = import3.pureProxy1(function (p0) {
            return [p0];
        });
    }
    View_NavComponent0.prototype.createInternal = function (rootSelector) {
        var parentRenderNode = this.renderer.createViewRoot(this.parentElement);
        this._el_0 = import3.createRenderElement(this.renderer, parentRenderNode, 'nav', new import3.InlineArray2(2, 'class', 'navbar navbar-inverse navbar-fixed-top'), null);
        this._text_1 = this.renderer.createText(this._el_0, '\n    ', null);
        this._el_2 = import3.createRenderElement(this.renderer, this._el_0, 'div', new import3.InlineArray2(2, 'class', 'container-fluid'), null);
        this._text_3 = this.renderer.createText(this._el_2, '\n        ', null);
        this._text_4 = this.renderer.createText(this._el_2, '\n        ', null);
        this._el_5 = import3.createRenderElement(this.renderer, this._el_2, 'div', new import3.InlineArray2(2, 'class', 'navbar-header'), null);
        this._text_6 = this.renderer.createText(this._el_5, '\n            ', null);
        this._el_7 = import3.createRenderElement(this.renderer, this._el_5, 'button', new import3.InlineArray16(10, 'aria-expanded', 'false', 'class', 'navbar-toggle collapsed', 'data-target', '#sb-top-navigation', 'data-toggle', 'collapse', 'type', 'button'), null);
        this._text_8 = this.renderer.createText(this._el_7, '\n                ', null);
        this._el_9 = import3.createRenderElement(this.renderer, this._el_7, 'span', new import3.InlineArray2(2, 'class', 'sr-only'), null);
        this._text_10 = this.renderer.createText(this._el_9, 'Toggle navigation', null);
        this._text_11 = this.renderer.createText(this._el_7, '\n                ', null);
        this._el_12 = import3.createRenderElement(this.renderer, this._el_7, 'span', new import3.InlineArray2(2, 'class', 'icon-bar'), null);
        this._text_13 = this.renderer.createText(this._el_7, '\n                ', null);
        this._el_14 = import3.createRenderElement(this.renderer, this._el_7, 'span', new import3.InlineArray2(2, 'class', 'icon-bar'), null);
        this._text_15 = this.renderer.createText(this._el_7, '\n                ', null);
        this._el_16 = import3.createRenderElement(this.renderer, this._el_7, 'span', new import3.InlineArray2(2, 'class', 'icon-bar'), null);
        this._text_17 = this.renderer.createText(this._el_7, '\n            ', null);
        this._text_18 = this.renderer.createText(this._el_5, '\n            ', null);
        this._el_19 = import3.createRenderElement(this.renderer, this._el_5, 'a', new import3.InlineArray4(4, 'class', 'navbar-brand', 'href', '#'), null);
        this._text_20 = this.renderer.createText(this._el_19, 'Brand', null);
        this._text_21 = this.renderer.createText(this._el_5, '\n        ', null);
        this._text_22 = this.renderer.createText(this._el_2, '\n\n        ', null);
        this._text_23 = this.renderer.createText(this._el_2, '\n        ', null);
        this._el_24 = import3.createRenderElement(this.renderer, this._el_2, 'div', new import3.InlineArray4(4, 'class', 'collapse navbar-collapse', 'id', 'sb-top-navigation'), null);
        this._text_25 = this.renderer.createText(this._el_24, '\n            ', null);
        this._el_26 = import3.createRenderElement(this.renderer, this._el_24, 'ul', new import3.InlineArray2(2, 'class', 'nav navbar-nav'), null);
        this._text_27 = this.renderer.createText(this._el_26, '\n                ', null);
        this._text_28 = this.renderer.createText(this._el_26, '\n                ', null);
        this._el_29 = import3.createRenderElement(this.renderer, this._el_26, 'li', import3.EMPTY_INLINE_ARRAY, null);
        this._el_30 = import3.createRenderElement(this.renderer, this._el_29, 'a', import3.EMPTY_INLINE_ARRAY, null);
        this._RouterLinkWithHref_30_3 = new import8.Wrapper_RouterLinkWithHref(this.parentView.injectorGet(import9.Router, this.parentIndex), this.parentView.injectorGet(import10.ActivatedRoute, this.parentIndex), this.parentView.injectorGet(import11.LocationStrategy, this.parentIndex));
        this._text_31 = this.renderer.createText(this._el_30, 'Home', null);
        this._text_32 = this.renderer.createText(this._el_26, '\n                ', null);
        this._el_33 = import3.createRenderElement(this.renderer, this._el_26, 'li', new import3.InlineArray2(2, 'class', 'dropdown'), null);
        this._text_34 = this.renderer.createText(this._el_33, '\n                    ', null);
        this._el_35 = import3.createRenderElement(this.renderer, this._el_33, 'a', new import3.InlineArray16(12, 'aria-expanded', 'false', 'aria-haspopup', 'true', 'class', 'dropdown-toggle', 'data-toggle', 'dropdown', 'href', '#', 'role', 'button'), null);
        this._text_36 = this.renderer.createText(this._el_35, 'Apps', null);
        this._el_37 = import3.createRenderElement(this.renderer, this._el_35, 'span', new import3.InlineArray2(2, 'class', 'caret'), null);
        this._text_38 = this.renderer.createText(this._el_33, '\n                    ', null);
        this._el_39 = import3.createRenderElement(this.renderer, this._el_33, 'ul', new import3.InlineArray2(2, 'class', 'dropdown-menu'), null);
        this._text_40 = this.renderer.createText(this._el_39, '\n                        ', null);
        this._el_41 = import3.createRenderElement(this.renderer, this._el_39, 'li', import3.EMPTY_INLINE_ARRAY, null);
        this._el_42 = import3.createRenderElement(this.renderer, this._el_41, 'a', import3.EMPTY_INLINE_ARRAY, null);
        this._RouterLinkWithHref_42_3 = new import8.Wrapper_RouterLinkWithHref(this.parentView.injectorGet(import9.Router, this.parentIndex), this.parentView.injectorGet(import10.ActivatedRoute, this.parentIndex), this.parentView.injectorGet(import11.LocationStrategy, this.parentIndex));
        this._text_43 = this.renderer.createText(this._el_42, 'Memory grid', null);
        this._text_44 = this.renderer.createText(this._el_39, '\n                        ', null);
        this._el_45 = import3.createRenderElement(this.renderer, this._el_39, 'li', import3.EMPTY_INLINE_ARRAY, null);
        this._el_46 = import3.createRenderElement(this.renderer, this._el_45, 'a', import3.EMPTY_INLINE_ARRAY, null);
        this._RouterLinkWithHref_46_3 = new import8.Wrapper_RouterLinkWithHref(this.parentView.injectorGet(import9.Router, this.parentIndex), this.parentView.injectorGet(import10.ActivatedRoute, this.parentIndex), this.parentView.injectorGet(import11.LocationStrategy, this.parentIndex));
        this._text_47 = this.renderer.createText(this._el_46, 'Tour of heroes (Angular.io)', null);
        this._text_48 = this.renderer.createText(this._el_39, '\n                        ', null);
        this._el_49 = import3.createRenderElement(this.renderer, this._el_39, 'li', import3.EMPTY_INLINE_ARRAY, null);
        this._el_50 = import3.createRenderElement(this.renderer, this._el_49, 'a', import3.EMPTY_INLINE_ARRAY, null);
        this._RouterLinkWithHref_50_3 = new import8.Wrapper_RouterLinkWithHref(this.parentView.injectorGet(import9.Router, this.parentIndex), this.parentView.injectorGet(import10.ActivatedRoute, this.parentIndex), this.parentView.injectorGet(import11.LocationStrategy, this.parentIndex));
        this._text_51 = this.renderer.createText(this._el_50, '2048', null);
        this._text_52 = this.renderer.createText(this._el_39, '\n                        ', null);
        this._el_53 = import3.createRenderElement(this.renderer, this._el_39, 'li', import3.EMPTY_INLINE_ARRAY, null);
        this._el_54 = import3.createRenderElement(this.renderer, this._el_53, 'a', import3.EMPTY_INLINE_ARRAY, null);
        this._RouterLinkWithHref_54_3 = new import8.Wrapper_RouterLinkWithHref(this.parentView.injectorGet(import9.Router, this.parentIndex), this.parentView.injectorGet(import10.ActivatedRoute, this.parentIndex), this.parentView.injectorGet(import11.LocationStrategy, this.parentIndex));
        this._text_55 = this.renderer.createText(this._el_54, 'Recognizer', null);
        this._text_56 = this.renderer.createText(this._el_39, '\n                    ', null);
        this._text_57 = this.renderer.createText(this._el_33, '\n                ', null);
        this._text_58 = this.renderer.createText(this._el_26, '\n            ', null);
        this._text_59 = this.renderer.createText(this._el_24, '\n            ', null);
        this._text_60 = this.renderer.createText(this._el_24, '\n        ', null);
        this._text_61 = this.renderer.createText(this._el_2, '\n        ', null);
        this._text_62 = this.renderer.createText(this._el_2, '\n    ', null);
        this._text_63 = this.renderer.createText(this._el_0, '\n    ', null);
        this._text_64 = this.renderer.createText(this._el_0, '\n', null);
        var disposable_0 = import3.subscribeToRenderElement(this, this._el_30, new import3.InlineArray2(2, 'click', null), this.eventHandler(this.handleEvent_30));
        var disposable_1 = import3.subscribeToRenderElement(this, this._el_42, new import3.InlineArray2(2, 'click', null), this.eventHandler(this.handleEvent_42));
        var disposable_2 = import3.subscribeToRenderElement(this, this._el_46, new import3.InlineArray2(2, 'click', null), this.eventHandler(this.handleEvent_46));
        var disposable_3 = import3.subscribeToRenderElement(this, this._el_50, new import3.InlineArray2(2, 'click', null), this.eventHandler(this.handleEvent_50));
        var disposable_4 = import3.subscribeToRenderElement(this, this._el_54, new import3.InlineArray2(2, 'click', null), this.eventHandler(this.handleEvent_54));
        this.init(null, (this.renderer.directRenderer ? null : [
            this._el_0,
            this._text_1,
            this._el_2,
            this._text_3,
            this._text_4,
            this._el_5,
            this._text_6,
            this._el_7,
            this._text_8,
            this._el_9,
            this._text_10,
            this._text_11,
            this._el_12,
            this._text_13,
            this._el_14,
            this._text_15,
            this._el_16,
            this._text_17,
            this._text_18,
            this._el_19,
            this._text_20,
            this._text_21,
            this._text_22,
            this._text_23,
            this._el_24,
            this._text_25,
            this._el_26,
            this._text_27,
            this._text_28,
            this._el_29,
            this._el_30,
            this._text_31,
            this._text_32,
            this._el_33,
            this._text_34,
            this._el_35,
            this._text_36,
            this._el_37,
            this._text_38,
            this._el_39,
            this._text_40,
            this._el_41,
            this._el_42,
            this._text_43,
            this._text_44,
            this._el_45,
            this._el_46,
            this._text_47,
            this._text_48,
            this._el_49,
            this._el_50,
            this._text_51,
            this._text_52,
            this._el_53,
            this._el_54,
            this._text_55,
            this._text_56,
            this._text_57,
            this._text_58,
            this._text_59,
            this._text_60,
            this._text_61,
            this._text_62,
            this._text_63,
            this._text_64
        ]), [
            disposable_0,
            disposable_1,
            disposable_2,
            disposable_3,
            disposable_4
        ]);
        return null;
    };
    View_NavComponent0.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import12.RouterLinkWithHref) && ((30 <= requestNodeIndex) && (requestNodeIndex <= 31)))) {
            return this._RouterLinkWithHref_30_3.context;
        }
        if (((token === import12.RouterLinkWithHref) && ((42 <= requestNodeIndex) && (requestNodeIndex <= 43)))) {
            return this._RouterLinkWithHref_42_3.context;
        }
        if (((token === import12.RouterLinkWithHref) && ((46 <= requestNodeIndex) && (requestNodeIndex <= 47)))) {
            return this._RouterLinkWithHref_46_3.context;
        }
        if (((token === import12.RouterLinkWithHref) && ((50 <= requestNodeIndex) && (requestNodeIndex <= 51)))) {
            return this._RouterLinkWithHref_50_3.context;
        }
        if (((token === import12.RouterLinkWithHref) && ((54 <= requestNodeIndex) && (requestNodeIndex <= 55)))) {
            return this._RouterLinkWithHref_54_3.context;
        }
        return notFoundResult;
    };
    View_NavComponent0.prototype.detectChangesInternal = function (throwOnChange) {
        var currVal_30_0_0 = this._arr_70('');
        this._RouterLinkWithHref_30_3.check_routerLink(currVal_30_0_0, throwOnChange, false);
        this._RouterLinkWithHref_30_3.ngDoCheck(this, this._el_30, throwOnChange);
        var currVal_42_0_0 = this._arr_71('/memory-grid');
        this._RouterLinkWithHref_42_3.check_routerLink(currVal_42_0_0, throwOnChange, false);
        this._RouterLinkWithHref_42_3.ngDoCheck(this, this._el_42, throwOnChange);
        var currVal_46_0_0 = this._arr_72('/team');
        this._RouterLinkWithHref_46_3.check_routerLink(currVal_46_0_0, throwOnChange, false);
        this._RouterLinkWithHref_46_3.ngDoCheck(this, this._el_46, throwOnChange);
        var currVal_50_0_0 = this._arr_73('/2048');
        this._RouterLinkWithHref_50_3.check_routerLink(currVal_50_0_0, throwOnChange, false);
        this._RouterLinkWithHref_50_3.ngDoCheck(this, this._el_50, throwOnChange);
        var currVal_54_0_0 = this._arr_74('/recognizer');
        this._RouterLinkWithHref_54_3.check_routerLink(currVal_54_0_0, throwOnChange, false);
        this._RouterLinkWithHref_54_3.ngDoCheck(this, this._el_54, throwOnChange);
        this._RouterLinkWithHref_30_3.checkHost(this, this, this._el_30, throwOnChange);
        this._RouterLinkWithHref_42_3.checkHost(this, this, this._el_42, throwOnChange);
        this._RouterLinkWithHref_46_3.checkHost(this, this, this._el_46, throwOnChange);
        this._RouterLinkWithHref_50_3.checkHost(this, this, this._el_50, throwOnChange);
        this._RouterLinkWithHref_54_3.checkHost(this, this, this._el_54, throwOnChange);
    };
    View_NavComponent0.prototype.destroyInternal = function () {
        this._RouterLinkWithHref_30_3.ngOnDestroy();
        this._RouterLinkWithHref_42_3.ngOnDestroy();
        this._RouterLinkWithHref_46_3.ngOnDestroy();
        this._RouterLinkWithHref_50_3.ngOnDestroy();
        this._RouterLinkWithHref_54_3.ngOnDestroy();
    };
    View_NavComponent0.prototype.handleEvent_30 = function (eventName, $event) {
        this.markPathToRootAsCheckOnce();
        var result = true;
        result = (this._RouterLinkWithHref_30_3.handleEvent(eventName, $event) && result);
        return result;
    };
    View_NavComponent0.prototype.handleEvent_42 = function (eventName, $event) {
        this.markPathToRootAsCheckOnce();
        var result = true;
        result = (this._RouterLinkWithHref_42_3.handleEvent(eventName, $event) && result);
        return result;
    };
    View_NavComponent0.prototype.handleEvent_46 = function (eventName, $event) {
        this.markPathToRootAsCheckOnce();
        var result = true;
        result = (this._RouterLinkWithHref_46_3.handleEvent(eventName, $event) && result);
        return result;
    };
    View_NavComponent0.prototype.handleEvent_50 = function (eventName, $event) {
        this.markPathToRootAsCheckOnce();
        var result = true;
        result = (this._RouterLinkWithHref_50_3.handleEvent(eventName, $event) && result);
        return result;
    };
    View_NavComponent0.prototype.handleEvent_54 = function (eventName, $event) {
        this.markPathToRootAsCheckOnce();
        var result = true;
        result = (this._RouterLinkWithHref_54_3.handleEvent(eventName, $event) && result);
        return result;
    };
    return View_NavComponent0;
}(import1.AppView));
//# sourceMappingURL=nav.component.ngfactory.js.map